var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Update"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 10.0879C1.24204 11.8295 2.04998 13.4432 3.29938 14.6805C4.54878 15.9178 6.17033 16.7099 7.91423 16.9349C9.65813 17.16 11.4276 16.8054 12.9502 15.9258C14.4727 15.0462 15.6189 13.6904 16.295 12.0672M16.295 12.0672V16.026M16.295 12.0672H12.3363",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6562 7.91211C16.4142 6.17049 15.6063 4.55676 14.3569 3.3195C13.1075 2.08224 11.4859 1.29008 9.74202 1.06506C7.99812 0.840045 6.22861 1.19464 4.70607 2.07423C3.18352 2.95383 2.0374 4.30961 1.3612 5.93275M1.3612 5.93275L1.3612 1.97403M1.3612 5.93275L5.31992 5.93275",
    stroke: "#0B1B4E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/Update-icon.870f7025f0d17eb81bac2de9858aeb3f.svg";
export { ForwardRef as ReactComponent };